import { Auth } from 'aws-amplify';
import * as api from "@/api";

const state = {
    app_user: {
        authenticated: false,
        access_token: null,
        longitude: null,
        latitude: null,
        is_at_drive_trough: null,
        user: null,
        temp_user: false,
    },
    web_user: {
        authenticated: false,
        user: { // todo: cog_user ?
            signInUserSession: {
                accessToken: {
                    jwtToken: null
                }
            }
        },
        account: {
            firstname: "",
            lastname: "",
            store_is_open: "",
        },
    },
    license_management: {
        loaded: 0,
        valid_21plus: 0,
        valid_18plus: 0,
        pending_dl: 0,
        ask_upload_dl: 0,
        valid_mc: 0,
        pending_mc: 0,
        sale_allowed: 0,
        temp_sale_allowed: 0,
        ask_to_upload_dl_again: 0,
    },
    registration: {
        email: "",
        user_name: "",
        promo_code: "",
        password: "",
        phone_number: "",
        tc_accepted: false,
        sms_allowed: true,
        email_allowed: true,
        first_name: "",
        last_name: "",
        university_id: 0,
        step: 0,
    },
    reset_username: "",
    reward_data: [],
    pending_delivery: 0,
    is21plus: false,
    logSigninResponse: '',
    logHrefClickResponse: '',
    survey_button_response: [],
}

const getters = {
    signedIn: (state) => {
        return state.web_user.authenticated || state.app_user.authenticated;
    },
    getResetUsername: (state) => {
        return state.reset_username;
    },
    is21plus: (state) => {
        return state.is21plus;
    },
    webUserAuthed: state => {
        return state.web_user.authenticated;
    },
    appUserAuthed: state => {
        return state.app_user.authenticated;
    },
    storeIsOpen: state => {
        return state.web_user.account.store_is_open;
    },
    getAccessToken: state => {
        if(!state.web_user.authenticated && !state.app_user.authenticated) {
            return "";
        }
        if(state.web_user.user.signInUserSession.accessToken.jwtToken && state.web_user.authenticated) {
            return state.web_user.user.signInUserSession.accessToken.jwtToken;
        }
        if(state.app_user.access_token && state.app_user.authenticated) {
            return state.app_user.access_token;
        }
        return "";
    },
    getFullName:  state => {
        if(state.web_user.authenticated) {
            if(state.web_user.account)
                return `${state.web_user.account.firstname} ${state.web_user.account.lastname}`
            return "";
        }
        if(state.app_user.authenticated) {
            return `${state.app_user.user.firstname} ${state.app_user.user.lastname}`
        }
    },
    getFirstName:  state => {
        if (state.web_user.authenticated) {
            if (state.web_user.account)
                return `${state.web_user.account.firstname}`
            return "";
        }
        if (state.app_user.authenticated) {
            return `${state.app_user.user.firstname}`
        }
    },
    getLastName:  state => {
        if (state.web_user.authenticated) {
            if (state.web_user.account)
                return `${state.web_user.account.lastname}`
            return "";
        }
        if (state.app_user.authenticated) {
            return `${state.app_user.user.lastname}`
        }
    },

    getCoordinates: state => {
        return {
            lat: +state.app_user.latitude,
            lng: +state.app_user.longitude
        }
    },

    getWebUserToken: state => state.web_user.user.signInUserSession.accessToken.jwtToken,

    getWebUserName: state => state.web_user.user.username,

    getUserAccountData: state => state.app_user.user,

    getLicenseManagement: state => state.license_management,

    getRewardsData: state => state.reward_data,

    getRegistrationData: state => state.registration,

    pending_delivery: state => state.pending_delivery,

    signup_phone_number: state => state.registration.phone_number,

    survey_button_response: state => state.survey_button_response,
}


const mutations = {
    findUser: async (state) => {
        try {
            const user = await Auth.currentAuthenticatedUser();
            state.web_user.user = user;
            state.web_user.authenticated = true;
        }
        catch (err) {
            state.web_user.authenticated = false;
            state.web_user.user = null;
        }
    },
    getAccount: (state, payload) => {
        api.getAccount({
            register_it: 0,
        }, {'authorization': payload.token}).then(val => {
            state.web_user.account = val.data;
            state.license_management = val.data.license_management;
            state.web_user.temp_user = false;
        })
    },
    setResetUsername: (state, payload) => {
        state.reset_username      = payload.reset_username;
    },
    setRegistrationPart1: (state, payload) => {
        state.registration.email      = payload.email;
        state.registration.user_name  = payload.user_name;
        state.registration.password   = payload.password;
        state.registration.promo_code = payload.promo_code;
        state.registration.step       = 1;
    },
    setRegistrationPart2: (state, payload) => {
        state.registration.phone_number  = payload.phone_number;
        state.registration.tc_accepted   = payload.tc_accepted;
        state.registration.sms_allowed   = payload.sms_allowed;
        state.registration.email_allowed = payload.email_allowed;
        state.registration.step          = 2;
    },
    setRegistrationPart3: (state, payload) => {
        state.registration.first_name    = payload.first_name;
        state.registration.last_name     = payload.last_name;
        state.registration.university_id = payload.university_id;
        state.registration.step          = 3;
    },
    registerAccount: (state, payload) => {

        api.getAccount({
            register_it: 1,
            notifysms: state.registration.sms_allowed,
            notifyemail: state.registration.email_allowed,
            firstname: state.registration.first_name,
            lastname: state.registration.last_name,
            university_id: state.registration.university_id,
            couponcode: state.registration.promo_code,
        }, {'authorization': payload.token}).then(val => {

            state.web_user.account = val.data;
            state.license_management = val.data.license_management;
            state.web_user.temp_user = false;

            state.registration.email = "";
            state.registration.user_name = "";
            state.registration.password = "";
            state.registration.promo_code = "";
            state.registration.phone_number = "";
            state.registration.first_name = "";
            state.registration.last_name = "";
            state.registration.university_id = 0;
            state.registration.tc_accepted = false;
            state.registration.sms_allowed = true;
            state.registration.email_allowed = true;
            state.registration.step = 0;
        })
    },
    set21plus: (state) => {
        state.is21plus = true;
        // todo: call API to record this in backend
    },
    setAppUserToken: (state, payload) => {
        state.app_user.access_token = payload.data.appat;
        state.app_user.longitude = payload.data.longitude;
        state.app_user.latitude = payload.data.latitude;
        state.app_user.is_at_drive_trough = payload.data.is_at_drive_trough;
        state.app_user.authenticated = true;
        state.web_user.authenticated = false;
    },
    setAppUserData: (state, payload) => {
        state.app_user.user = payload.data
        state.app_user.temp_user = false;
        state.license_management = payload.data.license_management;
    },
    uploadDocument: (state, payload) => {
        api.uploadDocument({
            image: payload.image,
            long: payload.long,
            lat: payload.lat,
            firstname: payload.firstname,
            lastname: payload.lastname,
            phototype: payload.phototype
        }, { 'authorization': payload.token }).then(val => {
            state.license_management = val.data
        })
    },

    setSigninLog: (state, payload) => {
        api.setSigninLog({
            signinusername: payload.signinusername,
            type: payload.type,
        }, { 'authorization': payload.token }).then(val => {
            state.logSigninResponse = val.data
        })
    },

    setHrefClickLog: (state, payload) => {
        api.setHrefClickLog({
            type: payload.type,
            url: payload.url,
        }, { 'authorization': payload.token }).then(val => {
            state.logHrefClickResponse = val.data
        })
    },

    surveyButtonClicked: (state, payload) => {
        api.surveyButtonClicked({
            type: payload.type, orderid: payload.orderid,
        }, { 'authorization': payload.token }).then(val => {
            state.survey_button_response = val.data
        })
    },

    getDLMCData: (state, payload) => {
        api.getDLMCData({}, { 'authorization': payload.token }).then(val => {
            state.license_management = val.data
        })
    },
    getPendingDeliveryStatus: (state, payload) => {
        api.getPendingDeliveryStatus({}, { 'authorization': payload.token }).then(val => {
            state.pending_delivery = val.data.pending_delivery
        })
    },
    loadRewardsData: (state, payload) => {
        api.loadRewardsData({}, { 'authorization': payload.token }).then(val => {
            state.reward_data = val.data
        })
    },


}

const actions = {
    findUser: (context) => {
        context.commit("findUser")
    },
    setAppUserToken: (context, payload) => {
        context.commit('setAppUserToken', payload)
    },
    setAppUserData: (context, payload) => {
        context.commit('setAppUserData', payload)
    },
    setRegistrationPart1: (context, payload) => {
        context.commit('setRegistrationPart1', payload)
    },
    setResetUsername: (context, payload) => {
        context.commit('setResetUsername', payload)
    },
    setRegistrationPart2: (context, payload) => {
        context.commit('setRegistrationPart2', payload)
    },
    setRegistrationPart3: (context, payload) => {
        context.commit('setRegistrationPart3', payload)
    },
    registerAccount: (context, payload) => {
        context.commit('registerAccount', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    uploadDocument: (context, payload) => {
        context.commit('uploadDocument', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    getDLMCData: (context, payload) => {
        context.commit('getDLMCData', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    getPendingDeliveryStatus: (context, payload) => {
        context.commit('getPendingDeliveryStatus', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    loadRewardsData: (context, payload) => {
        context.commit('loadRewardsData', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    getAccount: (context, payload) => {
        context.commit('getAccount', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },

    setSigninLog: (context, payload) => {
        context.commit('setSigninLog', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },

    setHrefClickLog: (context, payload) => {
        context.commit('setHrefClickLog', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },

    surveyButtonClicked: (context, payload) => {
        context.commit('surveyButtonClicked', { ...payload, token: context.rootGetters['auth/getAccessToken'] })
    },
    set21plus: (context) => {
        context.commit('set21plus')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
